/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Failed/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Failed({
  children,
  viewPath = "/DesignSystem/Report/ReportTable/Failed"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let constantData = 'Report ID:'
let reportIdValueData = fromData.useDataValue({ viewPath,
context: 'report',
path: 'id',
})
let aggregateData = fromAggregate.join(constantData, reportIdValueData)
  return (<React.Fragment
>
<div
  data-testid="Failed.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-2tr1MS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--ml-2-2tr1MS': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Failed to process. Please try again and contact support if the problem persists."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Report ID:'"
 data="report.id"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}